import React from 'react';
import PropTypes from 'prop-types';
import autoSelect from './autoSelect';
import testable from '@xingternal/malt-util/testable';
import { QA_MALT } from '@xingternal/malt-constants';

const TestableDiv = testable(QA_MALT, 'div');

const SelectList = ({
  children,
  highlightedValue,
  onOptionHover = () => {},
  onSelect = () => {},
  value,
  className,
  testId,
}) => (
  <TestableDiv
    onMouseOut={event => {
      event.target.value = null;
      onOptionHover(event);
    }}
    className={className}
    role="combobox"
    testId={testId}
  >
    {autoSelect(children, value, highlightedValue, onSelect, onOptionHover)}
  </TestableDiv>
);

SelectList.displayName = 'SelectList';
SelectList.propTypes = {
  /** A few `<SelectListOption />` nodes for this drop-down */
  children: PropTypes.node.isRequired,
  /** Custom className for the container div */
  className: PropTypes.string,
  /**
   * Value of the currently highlighted `<SelectListOption />`.
   *
   * The `highlightedValue` is supposed match the `value` or `children` prop of a child `<SelectListOption />`
   * If set, it will overwrite any `highlight` props on child `<SelectListOption />`
   */
  highlightedValue: PropTypes.any,
  /**
   * Callback for when a `<SelectListOption />` is being hovered.
   * Should be used to set highlight state.
   * Receives the value of the option on `event.target.value`
   */
  onOptionHover: PropTypes.func,
  /**
   * Callback for when a `<SelectListOption />` has been selected.
   * Should be used to set value state.
   * Receives the value of the option on `event.target.value`
   */
  onSelect: PropTypes.func,
  /**
   * Value of the currently selected `<SelectListOption />`.
   *
   * The `value` is supposed match the `value` or `children` prop of a child `<SelectListOption />`
   * If set, it will overwrite any `selected` props on child `<SelectListOption />`
   */
  value: PropTypes.any,
  /** define a testid for the list */
  testId: PropTypes.string,
};

export default SelectList;
